import { Application, Controller } from "@hotwired/stimulus";

class CsvShiftjisSettingController extends Controller {

  // ターゲットとして settingCheckbox と controlledCheckbox を定義
  static targets = ["settingCheckbox", "controlledCheckbox"]

  // settingCheckbox の change イベントで呼ばれるメソッド
  syncControlled() {
    // settingCheckbox の現在のチェック状態を取得
    const isChecked = this.settingCheckboxTarget.checked;

    // 全ての controlledCheckboxTargets に対して状態を同期させる
    this.controlledCheckboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked;
    });
  }
}

// Registered in admin.js
export { CsvShiftjisSettingController };
